import { useCallback } from 'react';
import { useStore } from 'hooks/useStore';
import { toast } from 'react-toastify';
import { FCColorType } from '../oocUpdated.type';
import { periodToLabel } from '../OOCCreateEdit/oocCreateEdit.logic';

export { periodToLabel };

export const getCellClass = (colorType: FCColorType, styles: Record<string, string>): string => {
  switch (colorType) {
    case 'new':
      return styles.cellNew;
    case 'modified':
    case 'ooc':
      return styles.cellModified;
    case 'removed':
      return styles.cellRemoved;
    default:
      return styles.cellUnchanged;
  }
};

export const deriveEmailData = (
  submission: ReturnType<typeof useStore>['OOCStoreUpdated']['currentSubmission']
) => {
  if (!submission) return null;
  const { emailPreview, adjustments } = submission;
  return {
    masAdj: emailPreview?.masAdjustments ?? adjustments.filter((a) => a.tab === 'MAS'),
    ncAdj: emailPreview?.ncAdjustments ?? adjustments.filter((a) => a.tab === 'NC'),
    provMasAdj: emailPreview?.provMasAdjustments ?? adjustments.filter((a) => a.tab === 'ProvMAS'),
    provNcAdj: emailPreview?.provNcAdjustments ?? adjustments.filter((a) => a.tab === 'ProvNC'),
    toField: emailPreview?.to ?? 'SC, Purchasing, PPS, Business Development, CSE',
    subjectField: emailPreview?.subject ?? `OOC Forecast Update - ${submission.id}`,
    attachmentField: emailPreview?.attachment ?? `${submission.id}_Forecast_Adjustments.xlsx`,
    greetingText:
      emailPreview?.bodyGreeting ??
      `Hello Team,\n\nPlease find below the out-of-cycle forecast adjustments for ${submission.id}. The following changes have been communicated and are now under Supply Chain review.`,
    signatureText:
      emailPreview?.bodySignature ?? `Best regards,\nDemand Planning Team`,
  };
};

export const useOOCCommunicateLogic = () => {
  const { OOCStoreUpdated: OOCStore } = useStore();
  const { currentSubmission, navigateToDashboard, markAsCommunicated } = OOCStore;

  const handleExportExcel = useCallback(() => {
    toast.success('Excel export started. File will download shortly.');
  }, []);

  const handleSendEmail = useCallback(() => {
    toast.success('Email sent successfully.');
  }, []);

  const handleMarkCommunicated = useCallback(() => {
    markAsCommunicated();
  }, [markAsCommunicated]);

  const emailData = currentSubmission ? deriveEmailData(currentSubmission) : null;

  return {
    currentSubmission,
    navigateToDashboard,
    handleExportExcel,
    handleSendEmail,
    handleMarkCommunicated,
    emailData,
  };
};
